import Tooltip from "../../../../../components/bases/tooltips/tooltip.js";



import { V2_recfps } from "../../../../../utils/timecodev2.js";
import ParamSlider from "./paramslider.js";
import ParamTitle from "./paramtitle.js";
import ParamCheckBox from "./paramcheckbox.js";
import ParamColorCombo from "./paramcolorcombo.js";
import ParamComboBox from "./paramcombobox.js";

import { configurations_getDefaultParams } from "../../../../../utils/configurations.js";
import { GlobalContext } from "../../../../../utils/globalprovider.js";
import "./tabs.css"
import React from "react";

class SubtitleTab extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        var defaultconf = configurations_getDefaultParams();
        this.onchange = this.onchange.bind(this);
        if ("stparams" in this.props)
        {
            if (!("lisibilityMode" in this.props.stparams))
                this.props.stparams.lisibilityMode = defaultconf.lisibilityMode;

            if (!("lisibilityIdealMM" in this.props.stparams))
                this.props.stparams.lisibilityIdealMM = defaultconf.lisibilityIdealMM;

            if (!("lisibilityMM" in this.props.stparams))
                this.props.stparams.lisibilityMM = defaultconf.lisibilityMM;

            if (!("lisibilityMaxMM" in this.props.stparams))
                this.props.stparams.lisibilityMaxMM = defaultconf.lisibilityMaxMM;

            if (!("i_stickBrokenSentence" in this.props.stparams))
                this.props.stparams.stickBrokenSentence = defaultconf.i_stickBrokenSentence;

            if (!("i_stickEndSentence" in this.props.stparams))
                this.props.stparams.i_stickEndSentence = defaultconf.i_stickEndSentence;

            if (!("i_stickInterSubtitle" in this.props.stparams))
                this.props.stparams.i_stickInterSubtitle = defaultconf.i_stickInterSubtitle;


            if (!("speechRateMode" in this.props.stparams))
                this.props.stparams.speechRateMode = defaultconf.speechRateMode;
            if (!("speechRate" in this.props.stparams))
                this.props.stparams.speechRate = defaultconf.speechRate;
            if (!("speechRateMM" in this.props.stparams))
                this.props.stparams.speechRateMM = defaultconf.speechRateMM;


            if (!("num" in this.props.stparams))
                this.props.stparams.num = defaultconf.num;
            if (!("den" in this.props.stparams))
                this.props.stparams.den = defaultconf.den;
            if (!("dropframe" in this.props.stparams))
                this.props.stparams.dropframe = defaultconf.dropframe;

            if (!("lisibilityIdealCSTMM" in this.props.stparams))
                this.props.stparams.lisibilityIdealCSTMM = defaultconf.lisibilityIdealCSTMM;

            if (!("lisibilityCSTMM" in this.props.stparams))
                this.props.stparams.lisibilityCSTMM = defaultconf.lisibilityCSTMM;

            if (!("lisibilityMaxCSTMM" in this.props.stparams))
                this.props.stparams.lisibilityMaxCSTMM = defaultconf.lisibilityMaxCSTMM;

            if (!("lisibilityIdealCST" in this.props.stparams))
                this.props.stparams.lisibilityIdealCST = defaultconf.lisibilityIdealCST;

            if (!("lisibilityCST" in this.props.stparams))
                this.props.stparams.lisibilityCST = defaultconf.lisibilityCST;

            if (!("lisibilityMaxCST" in this.props.stparams))
                this.props.stparams.lisibilityMaxCST = defaultconf.lisibilityMaxCST;

            if (!("createFirstSubtitle" in this.props.stparams))
                this.props.stparams.createFirstSubtitle = defaultconf.createFirstSubtitle;

            if (!("defaultColor" in this.props.stparams))
                this.props.stparams.defaultColor = defaultconf.defaultColor;

            if (!("usePreviousColor" in this.props.stparams))
                this.props.stparams.usePreviousColor = defaultconf.usePreviousColor;

            if (!("teletext" in this.props.stparams))
                this.props.stparams.teletext = defaultconf.teletext;
            if (!("teletext2" in this.props.stparams))
                this.props.stparams.teletext2 = defaultconf.teletext2;

        }

    }

    componentDidMount()
    {}
    componentWillUnmount()
    {}

    onchange (paramnumber, value)
    {

        
        switch (paramnumber)
        {
            case 0: // lisibilite
                this.props.stparams.lisibility = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 1: // lisibilite max
                this.props.stparams.lisibilityMax = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 2: // lisibilite ideal
                this.props.stparams.lisibilityIdeal = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 3:
                this.props.stparams.i_beforecp =  value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;

            case 4:
                this.props.stparams.i_aftercp =  value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 5:
                this.props.stparams.i_interst =  value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;

            case 6:
                this.props.stparams.i_min =  value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 7:
                this.props.stparams.i_max =  value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 8:
                this.props.stparams.maxLength = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 9:
                this.props.stparams.maxLengthColor = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 10:
                this.props.stparams.usecplist = value;                
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 11:
                this.props.stparams.i_toleranceIn = value;                
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 12: // mode de calcul lisibilité
                
                this.props.stparams.lisibilityMode = parseInt(value);
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 13: // algnement
                this.props.stparams.defaultAlignment = parseInt(value);
                this.props.onchange({type:"st", value: this.props.stparams});
                break;

                
            case 14: // lisibilite MM
                this.props.stparams.lisibilityMM = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 15: // lisibilite max MM
                this.props.stparams.lisibilityMaxMM = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 16: // lisibilite ideal MM
                this.props.stparams.lisibilityIdealMM = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;

            case 17: // stick sur sous titre terminé
                this.props.stparams.i_stickEndSentence = value; 
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 18: // stick sur sous titre phrase coupée
                this.props.stparams.i_stickBrokenSentence = value;  
                this.props.onchange({type:"st", value: this.props.stparams});
                break;


            case 19: // mode de calcul speechrate
                
                this.props.stparams.speechRateMode = parseInt(value);
                this.props.onchange({type:"st", value: this.props.stparams, recompute:true});
                break;
            
            case 20: // speechrate
                this.props.stparams.speechRate = value;
                this.props.onchange({type:"st", value: this.props.stparams, recompute:true});
                break;

            case 21: // speechratemm
                this.props.stparams.speechRateMM = value;
                this.props.onchange({type:"st", value: this.props.stparams, recompute:true});
                break;

            case 22: // stick sur sous titre simple
                this.props.stparams.i_stickInterSubtitle = value;  
                this.props.onchange({type:"st", value: this.props.stparams});
                break;

            case 23: // lisibilite st calculé
                this.props.stparams.lisibilityCST = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 24: // lisibilite max
                this.props.stparams.lisibilityMaxCST = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 25: // lisibilite ideal
                this.props.stparams.lisibilityIdealCST = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;

            case 26: // lisibilite MM
                this.props.stparams.lisibilityCSTMM = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 27: // lisibilite max MM
                this.props.stparams.lisibilityMaxCSTMM = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 28: // lisibilite ideal MM
                this.props.stparams.lisibilityIdealCSTMM = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;

            case 29: // Create First Subtitle
                this.props.stparams.createFirstSubtitle = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;

            case 30: // default Color
                this.props.stparams.defaultColor = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;

            case 31: // use previous color
                this.props.stparams.usePreviousColor = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;

            case 32: // teletext
                this.props.stparams.teletext = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 33: // teletext2
                this.props.stparams.teletext2 = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
            case 34: // Vertical Position
                this.props.stparams.verticalPos = value;
                this.props.onchange({type:"st", value: this.props.stparams});
                break;
        }
    }

    render()
    {

        var sliderslisibility = (<></>);
        if (this.props.stparams.lisibilityMode != 1)
        {
            sliderslisibility =   (
                <>
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {0}
                        key ="sliderLis"
                        text ={{cat:4,scat:0}}
                        value = {this.props.stparams.lisibility}
                        defaultvalue = {this.props.defaultsparams.lisibility}
                        coid = {this.props.codatas.coid}
                        min = {10}
                        max ={30}
                        unit = "c/s" />
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {1}
                        key ="sliderLisMax"
                        text ={{cat:4,scat:1}}
                        value = {this.props.stparams.lisibilityMax}
                        defaultvalue = {this.props.defaultsparams.lisibilityMax}
                        coid = {this.props.codatas.coid}
                        min = {10}
                        max ={30}
                        unit = "c/s" />
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {2}
                        key ="sliderLisIdeal"
                        text ={{cat:4,scat:2}}
                        value = {this.props.stparams.lisibilityIdeal}
                        defaultvalue = {this.props.defaultsparams.lisibilityIdeal}
                        coid = {this.props.codatas.coid}
                        min = {10}
                        max ={30}
                        unit = {"c/s"} />
                </>
            )

        }
        else
        {
            sliderslisibility =   (
                <>
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {14}
                        text ={{cat:4,scat:0}}
                        key ="sliderLisMM"
                        value = {this.props.stparams.lisibilityMM}
                        defaultvalue = {this.props.defaultsparams.lisibilityMM}
                        coid = {this.props.codatas.coid}
                        min = {100}
                        max ={300}
                        unit = "m/m" />
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {15}
                        key ="sliderLisMaxMM"
                        text ={{cat:4,scat:1}}
                        value = {this.props.stparams.lisibilityMaxMM}
                        defaultvalue = {this.props.defaultsparams.lisibilityMaxMM}
                        coid = {this.props.codatas.coid}
                        min = {100}
                        max ={300}
                        unit = "m/m" />
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {16}
                        key ="sliderLisIdealMM"
                        text ={{cat:4,scat:2}}
                        value = {this.props.stparams.lisibilityIdealMM}
                        defaultvalue = {this.props.defaultsparams.lisibilityIdealMM}
                        coid = {this.props.codatas.coid}
                        min = {100}
                        max ={300}
                        unit = {"m/m"} />
                </>
            )
        }

        var sliderslisibilityCST = (<></>);
        if (this.props.stparams.lisibilityMode != 1)
        {
            sliderslisibilityCST =   (
                <>
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {23}
                        key ="sliderLisCST"
                        text ={{cat:4,scat:0}}
                        value = {this.props.stparams.lisibilityCST}
                        defaultvalue = {this.props.defaultsparams.lisibilityCST}
                        coid = {this.props.codatas.coid}
                        min = {10}
                        max ={30}
                        unit = "c/s" />
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {24}
                        key ="sliderLisMaxCST"
                        text ={{cat:4,scat:1}}
                        value = {this.props.stparams.lisibilityMaxCST}
                        defaultvalue = {this.props.defaultsparams.lisibilityMaxCST}
                        coid = {this.props.codatas.coid}
                        min = {10}
                        max ={30}
                        unit = "c/s" />
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {25}
                        key ="sliderLisIdealCST"
                        text ={{cat:4,scat:2}}
                        value = {this.props.stparams.lisibilityIdealCST}
                        defaultvalue = {this.props.defaultsparams.lisibilityIdealCST}
                        coid = {this.props.codatas.coid}
                        min = {10}
                        max ={30}
                        unit = {"c/s"} />
                </>
            )

        }
        else
        {
            sliderslisibilityCST =   (
                <>
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {26}
                        text ={{cat:4,scat:0}}
                        key ="sliderLisCSTMM"
                        value = {this.props.stparams.lisibilityCSTMM}
                        defaultvalue = {this.props.defaultsparams.lisibilityCSTMM}
                        coid = {this.props.codatas.coid}
                        min = {100}
                        max ={300}
                        unit = "m/m" />
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {27}
                        key ="sliderLisMaxCSTMM"
                        text ={{cat:4,scat:1}}
                        value = {this.props.stparams.lisibilityMaxCSTMM}
                        defaultvalue = {this.props.defaultsparams.lisibilityMaxCSTMM}
                        coid = {this.props.codatas.coid}
                        min = {100}
                        max ={300}
                        unit = "m/m" />
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {28}
                        key ="sliderLisIdealCSTMM"
                        text ={{cat:4,scat:2}}
                        value = {this.props.stparams.lisibilityIdealCSTMM}
                        defaultvalue = {this.props.defaultsparams.lisibilityIdealCSTMM}
                        coid = {this.props.codatas.coid}
                        min = {100}
                        max ={300}
                        unit = {"m/m"} />
                </>
            )
        }




        var slidersspeechrate = (<></>);
        if (this.props.stparams.speechRateMode != 1)
        {
            slidersspeechrate =   (
                <>
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {20}
                        key ="sliderSpeechRate"
                        text ={{cat:4,scat:21}}
                        value = {this.props.stparams.speechRate}
                        defaultvalue = {this.props.defaultsparams.speechRate}
                        coid = {this.props.codatas.coid}
                        min = {10}
                        max ={40}
                        unit = "c/s" />
                </>
            )

        }
        else
        {
            slidersspeechrate =   (
                <>
                    <ParamSlider 
                        onchange = {this.onchange}
                        paramnumber = {21}
                        text ={{cat:4,scat:21}}
                        key ="sliderSpeechRateMM"
                        value = {this.props.stparams.speechRateMM}
                        defaultvalue = {this.props.defaultsparams.speechRateMM}
                        coid = {this.props.codatas.coid}
                        min = {80}
                        max ={300}
                        unit = "m/m" />
                </>
            )
        }



        var confname = this.context.language=="fr"?"Configuration par défaut.":"Default configuration.";

        if (this.props.codatas.coid > 0)
            confname = this.props.codatas.coid + " " + this.props.codatas.coname;



    return(<>
        <div className="tabsettingsFullTab">
            <ParamTitle
                textdirect = {confname}
                />
            <div className="tabsettingsTitleTab">
                {this.props.title}
                <br/><br/>
            </div>
            <div className="tabsettingscontentdata">
            <div className="tabsettingscontentdataScrollable">
                <div className="tabsettingsimpletitle">
                    {V2_recfps(this.props.stparams.num,this.props.stparams.den)}fps
                </div>
                <ParamTitle
                    text = {{cat:4, scat:26}}
                    />

                <div style={{marginTop:"5px", marginBottom:"5px"}}>
                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {32}
                    id = "STTELX"
                    text ={{cat:4,scat:27}}
                    value = {this.props.stparams.teletext}
                    defaultvalue = {this.props.defaultsparams.teletext}
                    coid = {this.props.codatas.coid}
                    
                />
                </div>

                <div style={{marginTop:"5px", marginBottom:"5px"}}>
                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {33}
                    id = "STTELX2"
                    text ={{cat:4,scat:28}}
                    value = {this.props.stparams.teletext2}
                    defaultvalue = {this.props.defaultsparams.teletext2}
                    coid = {this.props.codatas.coid}
                    
                />
                </div>


                <ParamTitle
                    text = {{cat:5, scat:0}}
                    />
                <ParamComboBox
                    onchange = {this.onchange}
                    paramnumber = {12}
                    text = {{cat:4,scat:12}}
                    id = "STCB01"
                    list = {
                        [
                            {cat:4,scat:13},
                            {cat:4,scat:14}
                        ]
                    }
                    value = {this.props.stparams.lisibilityMode}
                    defaultvalue = {this.props.defaultsparams.lisibilityMode}
                    coid = {this.props.codatas.coid}

                />
                {sliderslisibility}
                <ParamTitle
                    text = {{cat:5, scat:6}}
                />
                {sliderslisibilityCST}

                <ParamTitle
                    text = {{cat:5, scat:1}}
                    />

                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {3}
                    text ={{cat:4,scat:3}}
                    value = {this.props.stparams.i_beforecp }
                    defaultvalue = {this.props.defaultsparams.i_beforecp}
                    coid = {this.props.codatas.coid}
                    min = {0}
                    max ={10}
                    unit = "i" />

                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {4}
                    text ={{cat:4,scat:4}}
                    value = {this.props.stparams.i_aftercp }
                    defaultvalue = {this.props.defaultsparams.i_aftercp}
                    coid = {this.props.codatas.coid}
                    min = {0}
                    max ={10}
                    unit = "i" />

                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {5}
                    text ={{cat:4,scat:5}}
                    value = {this.props.stparams.i_interst }
                    defaultvalue = {this.props.defaultsparams.i_interst}
                    coid = {this.props.codatas.coid}
                    min = {0}
                    max ={10}
                    unit = "i" />

                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {6}
                    text ={{cat:4,scat:6}}
                    value = {this.props.stparams.i_min }
                    defaultvalue = {this.props.defaultsparams.i_min}
                    coid = {this.props.codatas.coid}
                    min = {16}
                    max ={50}
                    unit = "i" />

                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {7}
                    text ={{cat:4,scat:7}}
                    value = {this.props.stparams.i_max }
                    defaultvalue = {this.props.defaultsparams.i_max}
                    coid = {this.props.codatas.coid}
                    min = {25}
                    max ={250}
                    unit = "i" />



                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {11}
                    text ={{cat:4,scat:11}}
                    value = {this.props.stparams.i_toleranceIn }
                    defaultvalue = {this.props.defaultsparams.i_toleranceIn}
                    coid = {this.props.codatas.coid}
                    min = {0}
                    max ={12}
                    unit = "i" />

                <ParamTitle
                    text = {{cat:5, scat:4}}
                    />
                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {17}
                    text ={{cat:4,scat:19}}
                    value = {this.props.stparams.i_stickEndSentence }
                    defaultvalue = {this.props.defaultsparams.i_stickEndSentence}
                    coid = {this.props.codatas.coid}
                    min = {0}
                    max ={50}
                    unit = "i" />


                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {22}
                    text ={{cat:4,scat:22}}
                    value = {this.props.stparams.i_stickInterSubtitle }
                    defaultvalue = {this.props.defaultsparams.i_stickInterSubtitle}
                    coid = {this.props.codatas.coid}
                    min = {0}
                    max ={50}
                    unit = "i" />


                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {18}
                    text ={{cat:4,scat:20}}
                    value = {this.props.stparams.i_stickBrokenSentence }
                    defaultvalue = {this.props.defaultsparams.i_stickBrokenSentence}
                    coid = {this.props.codatas.coid}
                    min = {0}
                    max ={50}
                    unit = "i" />



                <ParamTitle
                    text = {{cat:5, scat:2}}
                    />
                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {8}
                    text ={{cat:4,scat:8}}
                    value = {this.props.stparams.maxLength}
                    defaultvalue = {this.props.defaultsparams.maxLength}
                    coid = {this.props.codatas.coid}
                    min = {20}
                    max ={60}
                    unit = "c" />

                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {9}
                    text ={{cat:4,scat:9}}
                    value = {this.props.stparams.maxLengthColor}
                    defaultvalue = {this.props.defaultsparams.maxLengthColor}
                    coid = {this.props.codatas.coid}
                    min = {20}
                    max ={60}
                    unit = "c" />

                <ParamComboBox
                    onchange = {this.onchange}
                    paramnumber = {13}
                    text = {{cat:4,scat:15}}
                    id = "STCB02"
                    list = {
                        [
                            {cat:4,scat:16},
                            {cat:4,scat:17},
                            {cat:4,scat:18}
                        ]
                    }
                    value = {this.props.stparams.defaultAlignment}
                    defaultvalue = {this.props.defaultsparams.defaultAlignment}
                    coid = {this.props.codatas.coid}

                />

                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {34}
                    key ="slidervpos"
                    text ={{cat:4,scat:30}}
                    value = {this.props.stparams.verticalPos}
                    defaultvalue = {this.props.defaultsparams.verticalPos}
                    coid = {this.props.codatas.coid}
                    min = {3}
                    max ={22}
                    unit = "" />


                <div style={{marginTop:"5px", marginBottom:"5px"}}>
                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {29}
                    id = "STFIRSTST"
                    text ={{cat:4,scat:23}}
                    value = {this.props.stparams.createFirstSubtitle}
                    defaultvalue = {this.props.defaultsparams.createFirstSubtitle}
                    coid = {this.props.codatas.coid}
                    
                />
                </div>
                <div style={{marginTop:"5px", marginBottom:"5px"}}>
                <ParamColorCombo
                    value = {this.props.stparams.defaultColor}
                    text ={{cat:4,scat:24}}
                    id = "STDEFCO"
                    paramnumber = {30}
                    defaultvalue = {this.props.defaultsparams.defaultColor}
                    coid = {this.props.codatas.coid}
                    onchange = {this.onchange}
                    />
                </div>
                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {31}
                    id = "STUSEP"
                    text ={{cat:4,scat:25}}
                    value = {this.props.stparams.usePreviousColor}
                    defaultvalue = {this.props.defaultsparams.usePreviousColor}
                    coid = {this.props.codatas.coid}
                />

                <ParamTitle
                    text = {{cat:5, scat:5}}
                    />
                <ParamComboBox
                    onchange = {this.onchange}
                    paramnumber = {19}
                    text = {{cat:4,scat:12}}
                    id = "STCB01SR"
                    list = {
                        [
                            {cat:4,scat:13},
                            {cat:4,scat:14}
                        ]
                    }
                    value = {this.props.stparams.speechRateMode}
                    defaultvalue = {this.props.defaultsparams.speechRateMode}
                    coid = {this.props.codatas.coid}

                />
                {slidersspeechrate}


                <ParamTitle
                    text = {{cat:5, scat:3}}
                    />
                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {10}
                    id = "ST01"
                    text ={{cat:4,scat:10}}
                    value = {this.props.stparams.usecplist}
                    defaultvalue = {this.props.defaultsparams.usecplist}
                    coid = {this.props.codatas.coid}
                />
                <br/>
                <br/>
                <br/>
            </div>
        </div>

            
        </div>
        </>
        )
    }

}

export default SubtitleTab